import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Loader from 'components/Loader';
import { createErrorFromResponse } from 'core/Error';

interface IProps {
  isLoading?: boolean;
  error?: unknown;
  children: ReactNode;
}

const LayoutContent: FC<IProps> = ({ isLoading, error, children }: IProps) => {
  if (isLoading)
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );

  if (error) return <p>{createErrorFromResponse(error).message}</p>;
  return <>{children}</>;
};

export default LayoutContent;

const LoaderWrapper = styled.div`
  min-height: 17rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
